import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <>
      <Helmet>
        <title>Mentions Légales | Mehdi Richa - Formateur & Auditeur Qualité Vaucluse</title>
        <meta 
          name="description" 
          content="Mentions légales du site de Mehdi Richa, formateur et auditeur qualité dans le Vaucluse." 
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="py-16 md:py-24 bg-white" data-testid="mentions-legales">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8"
            data-testid="back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <h1 className="font-serif text-4xl font-bold text-slate-900 mb-8">
            Mentions Légales
          </h1>

          <div className="prose prose-slate max-w-none">
            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                1. Éditeur du site
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Le présent site est édité par :
              </p>
              <ul className="text-slate-600 space-y-2">
                <li><strong>Nom :</strong> Mehdi Richa</li>
                <li><strong>Activité :</strong> Formateur et auditeur qualité indépendant</li>
                <li><strong>Adresse :</strong> Avignon, Vaucluse (84), France</li>
                <li><strong>Email :</strong> mehdi.richa.formation@gmail.com</li>
                <li><strong>Téléphone :</strong> 06 20 96 89 80</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                2. Hébergement
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Ce site est hébergé par Emergent Labs.<br />
                Pour toute question relative à l'hébergement, veuillez contacter l'éditeur du site.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                3. Propriété intellectuelle
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) 
                est la propriété exclusive de Mehdi Richa, à l'exception des éléments provenant 
                de tiers (images Unsplash sous licence libre).
              </p>
              <p className="text-slate-600 leading-relaxed">
                Toute reproduction, représentation, modification, publication ou adaptation de tout 
                ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est 
                interdite, sauf autorisation écrite préalable de Mehdi Richa.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                4. Protection des données personnelles
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la 
                loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, 
                de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                <strong>Données collectées :</strong> Ce site ne collecte aucune donnée personnelle 
                de manière automatique. Les seules données traitées sont celles que vous communiquez 
                volontairement par email lors d'une prise de contact.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                <strong>Finalité :</strong> Les données communiquées par email sont utilisées 
                uniquement pour répondre à vos demandes de renseignements concernant les prestations 
                de formation ou d'audit.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                <strong>Conservation :</strong> Les données sont conservées pendant la durée 
                nécessaire au traitement de votre demande, puis archivées conformément aux 
                obligations légales.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Pour exercer vos droits, vous pouvez contacter Mehdi Richa à l'adresse : 
                <a href="mailto:mehdi.richa.formation@gmail.com" className="text-blue-600 hover:text-blue-700 ml-1">
                  mehdi.richa.formation@gmail.com
                </a>
              </p>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                5. Cookies
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Ce site n'utilise pas de cookies de suivi ou de cookies publicitaires. 
                Seuls des cookies techniques strictement nécessaires au fonctionnement du site 
                peuvent être utilisés.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                6. Liens hypertextes
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Le site peut contenir des liens vers d'autres sites web. Mehdi Richa n'exerce 
                aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu 
                ou aux traitements de données qu'ils effectuent.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                7. Limitation de responsabilité
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Les informations contenues sur ce site sont aussi précises que possible et le site 
                est périodiquement mis à jour, mais peut toutefois contenir des inexactitudes, des 
                omissions ou des lacunes.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Mehdi Richa ne pourra être tenu responsable des dommages directs et indirects 
                causés au matériel de l'utilisateur, lors de l'accès au site, résultant de 
                l'utilisation d'un matériel ne répondant pas aux spécifications techniques 
                requises, ou de l'apparition d'un bug ou d'une incompatibilité.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                8. Droit applicable
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, 
                et après échec de toute tentative de recherche d'une solution amiable, les tribunaux 
                français seront seuls compétents pour connaître de ce litige.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-slate-900 mb-4">
                9. Crédits
              </h2>
              <p className="text-slate-600 leading-relaxed">
                <strong>Photos :</strong> Unsplash (licence libre)<br />
                <strong>Icônes :</strong> Lucide React
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-slate-500 text-sm">
              Dernière mise à jour : Juillet 2025
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default MentionsLegales;
